<template>
  <Modal :id="id" :modalTitle="modalTitle" :class="classes" :onClose="onClose">
    <div v-if="content === 'content1'">
      <div>
        <div class="col-12 d-flex mx-1">
          <div class="generalTitleItemModal mr-2">Nº Contrato:</div>
          <div>{{ contractId }}</div>
        </div>
        <form autocomplete="off" id="issueForm">
          <div class="row mx-1">
            <div class="col-12 col-md-3">
              <div class="form-group">
                <label class="generalLabel" for="status"><span className='text-danger'>*</span> Estado</label>
                <VueNextSelect class="form-control generalInput" id="status" :options="statusData"
                  v-model.trim="v$.status.$model" placeholder="" searchable clear-on-close close-on-select>
                </VueNextSelect>
                <div v-if="v$.status.$dirty">
                  <small class="form-text text-danger" v-if="v$.status.required.$invalid">Campo requerido</small>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-4 mx-1">
            <div class="col-12">
              <button class="btn btn-primary float-right generalPrimaryButton mw-100" id="submitButton"
                v-bind:class="{ disabled: v$.$invalid || loading }" :disabled="v$.$invalid || loading"
                @click="submit($event)">
                <span v-if="loading">
                  <img src="../../../../../assets/loader.svg" height="25" alt="">
                </span>
                <span v-else>Crear</span>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div v-if="content === 'content2'">
      <label class="generalLabel">{{ message }}</label>
    </div>
    <button :id="id + 'CierreModal'" style="display: none;" data-dismiss="modal" />
  </Modal>
</template>
<script>
import Modal from '../../../Shared/Modal.vue';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators'
import VueNextSelect from "vue-next-select";
import axios from 'axios';
import {  statusData, statusDataTraduction } from "../common.js";


export default {
  name: 'editIssue',
  setup() {
    return { v$: useVuelidate() }
  },
  props: [
    'id',
    'modalTitle',
    'class',
    'issue',
  ],
  components: {
    VueNextSelect,
    Modal,
  },
  created() {
    this.status = statusData[statusDataTraduction.indexOf(this.issue.status)];
  },
  data() {
    return {
      classes: this.class,
      contractId: this.issue.contractId,
      statusData: statusData,
      statusDataTraduction: statusDataTraduction,
      status: "",
      content: 'content1',
      loading: false,
      message: '',
    };
  },
  validations() {
    return {
      status: {
        required,
      }
    }
  },
  methods: {
    submit(e) {
      e.preventDefault();
      this.message = '';
      this.loading = true;
      const bodyToSend = {
        status: this.statusDataTraduction[this.statusData.indexOf(this.status)],
      }
      axios.patch(`/incident/${this.issue.incidentId}`, bodyToSend)
        .then((response) => {
          this.selectTab('content2');
          this.loading = false
          this.message = 'Se ha realizado la operación correctamente.';
          this.$emit("sendRefreshIssuesList");
          console.log(response);
        })
        .catch(() => {
          this.selectTab('content2');
          this.loading = false;
          this.message = 'Ha ocurrido un error al realizar la operación.';
        });
    },
    selectTab(id) {
      this.content = id
    },
    onClose() {
      document.querySelector(`#${this.id}CierreModal`).click();
      this.$emit("closeModal", '');
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>